export const metIntegration = {
    wxtilesv3: {
        test: 'https://d225mq688ta02h.cloudfront.net',
        acceptance: 'https://dexuwrqewpd0q.cloudfront.net',
        prod: 'https://d3ssdcjnzeyu4r.cloudfront.net',
    },
    getUserPermissions: {
        test: 'https://d1z1h51ya97gdt.cloudfront.net/test/getUserPermissions',
        acceptance: 'https://du2cech2p7lfp.cloudfront.net/acceptance/getUserPermissions',
        prod: 'https://d305qb78ptntw7.cloudfront.net/prod/getUserPermissions',
    },
    metserviceApi: {
        test: 'https://d3061316qp1842.cloudfront.net',
        acceptance: 'https://d1q3yvgf8m54uc.cloudfront.net',
        prod: 'https://d1krpsa7h763b8.cloudfront.net',
    },
    // lightningApi is deprecated, use metIntegrationV2.lightningApi instead
    lightningApi: {
        test: 'd1x82c15ijwck7.cloudfront.net',
        acceptance: 'dmub7wzwvk10l.cloudfront.net',
        prod: 'd1ki2g8ys6ysmc.cloudfront.net',
    },
    // lightningFeed is deprecated, use metIntegrationV2.lightningApi instead
    lightningFeed: {
        test: 'dvbyrpjy8w4yq.cloudfront.net',
        acceptance: 'd2w11ee4s4je57.cloudfront.net',
        prod: 'd14qvk8i6mdfl2.cloudfront.net',
    },
    metraweatherOkta: {
        test: 'https://d3imn4osh19cy1.cloudfront.net',
        acceptance: 'https://df4xsqw6m24gb.cloudfront.net',
        prod: 'https://d17bdbtow6tiya.cloudfront.net',
    },
};
export const metIntegrationV2 = {
    lightningApi: {
        dev: 'appservice-lightning-dev-australiaeast.azurewebsites.net',
        test: 'appservice-lightning-dev-australiaeast.azurewebsites.net',
        // test: 'appservice-lightning-test-australiaeast.azurewebsites.net', // is broken, not worth fixing
        acceptance: 'appservice-lightning-uat-australiaeast.azurewebsites.net',
        uat: 'appservice-lightning-uat-australiaeast.azurewebsites.net',
        prod: 'appservice-lightning-prod-australiaeast.azurewebsites.net',
    },
};
